import { FC } from 'react'
import { AboutAttorneyFormContainer } from 'src/components/application/defaultComponents'
import StepBullet from 'src/components/basic/StepBullet'
import { LeftBar } from 'src/components/basic/LeftBar'
import StandardInput from 'src/components/basic/StandardInput'
import { AttorneyData } from 'src/dtos/applicationData'
import Button from 'src/components/basic/Button'
import { MdKeyboardArrowDown, MdKeyboardArrowUp } from 'react-icons/md'
import { ValidationErrorMessage } from 'src/components/basic/ValidationErrorMessage/ValidationErrorMessage'

interface Props {
  attorney: AttorneyData;
  attorneyNumber: number;
  setAttorneyInfo: (changes: Partial<AttorneyData>) => void;
  removeAttorney: () => void;
  status: {
    isAccordion: boolean;
    isOpen: boolean;
  }
  isIncorrect?: boolean;
  toggleOpenAccordion?: () => void;
  disableAddNewAttorneys?: boolean;
  errorCodes: string[];
}

const Attorney: FC<Props> = ({
  attorney,
  attorneyNumber,
  setAttorneyInfo,
  removeAttorney,
  isIncorrect,
  status,
  toggleOpenAccordion,
  disableAddNewAttorneys,
  errorCodes = [],
}) => {

  const formContainerClasses = `form-container `;

  return (
    <AboutAttorneyFormContainer>
      <LeftBar />
      <div className={formContainerClasses}>
        <div className='form-title'>
          <StepBullet isComplete>1</StepBullet>
          {status.isAccordion ? (
            <h6>ABOUT: {[attorney?.firstName, attorney?.lastName].join(' ')}</h6>
          ) : null}
          <button onClick={toggleOpenAccordion}>
            {status.isOpen ? (
              <MdKeyboardArrowUp />
            ) : (
              <MdKeyboardArrowDown />
            )}
          </button>
        </div>
        <div className='form-content'>
          <StandardInput
            label='First Name'
            value={attorney.firstName}
            onChange={e => setAttorneyInfo({ firstName: e.target.value })}
            isIncorrect={isIncorrect && !attorney.firstName}
            errorMessage={isIncorrect && !attorney.firstName ? 'This is a required field' : ''}
            errorCode={errorCodes[0]}
          />
          <StandardInput
            label='Last Name'
            value={attorney.lastName}
            onChange={e => setAttorneyInfo({ lastName: e.target.value })}
            isIncorrect={isIncorrect && !attorney.lastName}
            errorMessage={isIncorrect && !attorney.lastName ? 'This is a required field' : ''}
            errorCode={errorCodes[1]}
          />
          <ValidationErrorMessage errorCode={`EC306:${attorneyNumber - 1}`} />
          {disableAddNewAttorneys !== true && attorneyNumber > 1 ? (
            <Button variant='error' onClick={removeAttorney}>
              Remove Attorney
            </Button>
          ) : null}
        </div>
      </div>
    </AboutAttorneyFormContainer>
  )
}

export default Attorney